import axios, { AxiosError } from "axios"
import { jwtDecode } from "jwt-decode"
import { Mutex } from "async-mutex"

import store from "../../store"


class TokenHandler {

  private _mutex: Mutex = new Mutex()

  private async _refreshToken() {

    // BEWARE: A race condition may occur when two (or more) calls are made simultaneously to _refreshToken()

    await (navigator as any).locks.request("refresh_token", async () => { // To prevent the risk of a race condition between tabs of the same navigator
      await this._mutex.runExclusive(async () => { // To prevent the risk of a race condition inside the same tab
        console.log(`---> _refreshToken(): ${new Date().toLocaleDateString("fr-FR", { month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' })}`)
        
        try {
          const resp = await axios.get(`/auth/access_token`, {
            withCredentials: true
          })
    
          if (resp.data) {
            const { data } = resp

            if (data?.access_token && data?.access_token_expiry) {
              const { access_token } = data
              sessionStorage.setItem("jwt", access_token)
            }
          }
        }
        catch (err) {
          const error = err as Error | AxiosError

          if (axios.isAxiosError(error)) {
            if (error.response?.status === 401) {

              const user = store.get("user")
              const jwt = sessionStorage.getItem("jwt")

              if (user != null || jwt != null) {
                store.set("user", undefined)
                sessionStorage.removeItem("jwt")

                window.location.href = "/"
              }
            }
            else {
              throw err
            }
          }
          else {
            throw err
          }
        }
      })
    })
  }

  private async _refreshTokenIfNeeded() {
    const jwt = sessionStorage.getItem("jwt")

    if (jwt) {
      const { exp } = jwtDecode(jwt)

      if (exp) {
        if ((exp - 60) < Math.round(Date.now() / 1000)) {
          await this._refreshToken()
        }
      }
    }
    else {
      await this._refreshToken()
    }
  }

  public async getToken() {
    await this._refreshTokenIfNeeded()
    
    return sessionStorage.getItem("jwt")
  }

  public resetToken() {
    sessionStorage.removeItem("jwt")
  }

  public init(backend: string) {
    try {
      axios.interceptors.request.use(async (cfg) => {

        if (cfg.url && cfg?.url[0] === "/") {
          const gatewayUrl = new URL(backend);
          cfg.baseURL = `${gatewayUrl.protocol}//${gatewayUrl.host}`

          cfg.withCredentials = true;

          if (cfg.url !== '/auth/sign-in'
            && cfg.url !== '/auth/sign-up'
            && cfg.url !== '/auth/access_token'
            && cfg.url !== '/auth/forgot-my-password'
            && cfg.url !== '/auth/reset-password') {

            const jwt = await tokenHandler.getToken()

            if (jwt) {
              cfg.headers.Authorization = `Bearer ${jwt}`;
            }
          }
        }

        return cfg
      })
    }
    catch (err) {
      throw err;
    }
  }

}

export const tokenHandler = new TokenHandler()
